// extracted by mini-css-extract-plugin
export default {"pagoCard":"PagoCard_pagoCard__HnJ8i","icono":"PagoCard_icono__KO3yb","contInfo":"PagoCard_contInfo__din2v","fondoSub":"PagoCard_fondoSub__8gVj5"};